import { jsx, jsxs } from 'react/jsx-runtime';
import classNames from 'classnames';
import chunk from 'lodash.chunk';
import { Overlay, Card, Title, Row, Col, Selectable } from '@mirohq-internal/website-ui-foundation';

const OverlayLanguageList = ({ title, target, handleClose, show, selectedValue, items, handleSelect })=>{
    const groupsItems = chunk(items, 7);
    return jsx(Overlay, {
        target: target.current,
        show: show,
        placement: "top-start",
        rootClose: true,
        rootCloseEvent: "click",
        onHide: handleClose,
        children: ({ placement: _placement, arrowProps: _arrowProps, show: _show, popper: _popper, hasDoneInitialMeasure: _hasDoneInitialMeasure, ...props })=>jsx(Card, {
                ...props,
                "data-testid": "overlay-language-list",
                className: classNames('d-none d-md-block ms-n300 border-0'),
                children: jsxs(Card.Body, {
                    className: "p-400",
                    children: [
                        jsx(Title, {
                            render: "h2",
                            className: "d-block category mb-200",
                            children: title
                        }),
                        jsx(Row, {
                            className: "d-flex gap-600",
                            children: groupsItems.map((group)=>{
                                return jsx(Col, {
                                    className: "d-flex flex-column gap-300",
                                    children: group.map((item)=>jsx(Selectable, {
                                            style: {
                                                minWidth: '176px'
                                            },
                                            selected: selectedValue === item.label,
                                            selectedIcon: "CheckMark",
                                            href: item.href,
                                            eventKey: item.label,
                                            onSelect: handleSelect,
                                            children: item.label
                                        }, item.label))
                                }, JSON.stringify(group));
                            })
                        })
                    ]
                })
            })
    });
};

export { OverlayLanguageList };
